module.exports = __webpack_public_path__ + "img/jiantou3.b003720d.png";